import { useEffect } from "react";

type ShortcutHandler = (e: KeyboardEvent) => void;

export const useKeyboardShortcuts = (shortcuts: Record<string, ShortcutHandler>) => {
	useEffect(() => {
		const handler = (e: KeyboardEvent) => {
			const mod = e.metaKey || e.ctrlKey;
			const key = e.key.toLowerCase();

			// Don't trigger shortcuts when typing in inputs (except Escape)
			const isInput =
				(e.target as HTMLElement)?.tagName === "INPUT" ||
				(e.target as HTMLElement)?.tagName === "TEXTAREA" ||
				(e.target as HTMLElement)?.contentEditable === "true";

			if (key === "escape") {
				shortcuts["escape"]?.(e);
				return;
			}

			if (isInput) return;

			if (mod && key === "k") {
				e.preventDefault();
				shortcuts["mod+k"]?.(e);
			} else if (mod && key === "n") {
				e.preventDefault();
				shortcuts["mod+n"]?.(e);
			} else if (key === "/") {
				e.preventDefault();
				shortcuts["mod+k"]?.(e); // / also focuses search
			} else if (e.altKey && key === "arrowup") {
				e.preventDefault();
				shortcuts["alt+up"]?.(e);
			} else if (e.altKey && key === "arrowdown") {
				e.preventDefault();
				shortcuts["alt+down"]?.(e);
			}
		};

		window.addEventListener("keydown", handler);
		return () => window.removeEventListener("keydown", handler);
	}, [shortcuts]);
};
